module.exports = __webpack_public_path__ + "img/vertical_6_5_5.4a68fe25.png";